import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  toggle() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.toggle('hidden')

      // Toggle the hamburger/close icons
      const button = this.element.querySelector('button[aria-controls="mobile-menu"]')
      if (button) {
        const isExpanded = button.getAttribute('aria-expanded') === 'true'
        button.setAttribute('aria-expanded', !isExpanded)

        // Toggle icon visibility
        const hamburger = button.querySelector('svg:first-of-type')
        const close = button.querySelector('svg:last-of-type')

        if (hamburger && close) {
          hamburger.classList.toggle('hidden')
          hamburger.classList.toggle('block')
          close.classList.toggle('hidden')
          close.classList.toggle('block')
        }
      }
    }
  }
}
